import { render } from "./StudentTrainingCalendar.vue?vue&type=template&id=fe09e310"
import script from "./StudentTrainingCalendar.vue?vue&type=script&lang=js"
export * from "./StudentTrainingCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__